// extracted by mini-css-extract-plugin
module.exports = {"phone":"PhoneNumber_phone__2oiTp"};